import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  // const [darkMode, setDarkMode] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // ✅ Scroll Effect to add "scrolled" class to navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ✅ Dark Mode Toggle
  // const toggleDarkMode = () => {
  //   setDarkMode(!darkMode);
  //   document.body.classList.toggle("dark-mode");
  // };

  const closeNavbar = () => {
  const navbarToggler = document.querySelector(".navbar-toggler");
  const navbarCollapse = document.querySelector(".navbar-collapse");

  if (navbarCollapse.classList.contains("show")) {
    navbarToggler.click(); // programmatically collapse the navbar
  }
};


  return (
    <header className={`fixed-top ${isScrolled ? "header-logo-dark bg-white" : "bg-transparent "}`}>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <NavLink className="navbar-brand" to="/#">
           <img
              src={isScrolled ? "/assets/images/logo-dark.png" : "/assets/images/logo.png"}
              alt="BB Soft"
              className="img-fluid"
            />
          </NavLink>
          

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
            aria-label="Toggle navigation">
            <span>
              <i className="fa-solid fa-sliders"></i>
            </span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav mb-3 mb-md-0">
               {/* services Dropdown Nav Item */}
               <li className="nav-item dropdown">
                  {/* Toggler link for the dropdown */}
                  <NavLink
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false" 
                  >
                    Services
                  </NavLink>

                  {/* Dropdown menu */}
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                      <NavLink className="dropdown-item" to="/offshoreoffices" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                         Offshore Offices
                      </NavLink>
                      <NavLink className="dropdown-item" to="/web-development" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                          Web Development Services
                      </NavLink>
                      <NavLink className="dropdown-item" to="/mobile-app-development" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                          Mobile Application Development
                      </NavLink>
                      <NavLink className="dropdown-item" to="/ui-ux" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                         UI/UX Design Services
                      </NavLink>
                      <NavLink className="dropdown-item" to="/business-intelligence" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                         Business Intelligence Services
                      </NavLink>
                      <NavLink className="dropdown-item" to="/third-party-api-integration" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                         THIRD PARTY API INTEGRATION
                      </NavLink>
                    </li>
                  </ul>
                </li>

              <li className="nav-item"><NavLink className="nav-link" to="/about-us" onClick={closeNavbar}>About</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/success-stories" onClick={closeNavbar}>Works</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/careers" onClick={closeNavbar}>Careers</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/team" onClick={closeNavbar}>Offshore Team</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/contact" onClick={closeNavbar}>Contact</NavLink></li>

              {/* Dropdown Nav Item */}
                <li className="nav-item dropdown">
                  {/* Toggler link for the dropdown */}
                  <NavLink
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Pages
                  </NavLink>

                  {/* Dropdown menu */}
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                      <NavLink className="dropdown-item" to="/gallery" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                        Gallery 
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/blogs" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                         Blogs
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/faqs" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                         FAQ
                      </NavLink>
                    </li>
                     <li>
                      <NavLink className="dropdown-item" to="/why-choose-us" onClick={closeNavbar} style={{ color: "#3a3a3a" }}>
                         Why Choose Us
                      </NavLink>
                    </li>
                    
                   
                  </ul>
                </li>

            </ul>

            <button className="btn btn-primary get-quotes">
              <NavLink to="/contact" onClick={closeNavbar}>Let's Get Together</NavLink>
            </button>

            {/* <button id="darkmode-button" className="btn rounded-circle" onClick={toggleDarkMode}>
              <i className={`fa-solid ${darkMode ? "fa-sun" : "fa-moon"}`}></i>
            </button> */}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
